import { PagedSearch } from '../../../shared/model/paged-search.model';

export class WebContentSearchDto extends PagedSearch {
  ProfileId: number;
  ContentTitle: string;
  ContentFormat: string;
  ContentTypeId: number;
  ContentId: number;
  IncludeUrl: boolean;

  constructor(profileId = 0, includeUrl = false) {
    super();
    this.ProfileId = profileId;
    this.IncludeUrl = includeUrl;
    this.PageSize = 5;
  }
}
